// app/src/main.tsx
import "./polyfills"; // MUST be first

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

// DEV-only: register browser console helpers like window.checkProgram()
if (import.meta.env.DEV) {
  import("./dev/programCheck").catch((e) => {
    console.warn("[main] dev helper import failed:", e);
  });
}

console.log("[main] 🚀 START", new Date().toISOString());

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
